module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic13.976a682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic13.png
// module id = 512
// module chunks = 1